"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (params) {
    if (!Object.keys(params).length) {
        return '';
    }
    var searchParams = new URLSearchParams();
    Object.keys(params).forEach(function (k) {
        var param = params[k];
        if (typeof param !== 'undefined') {
            searchParams.append(k, typeof param === 'number' ? param.toString() : param);
        }
    });
    var paramsStr = searchParams.toString();
    return paramsStr ? "?" + paramsStr : '';
});
